const Pagination = (props) => {
	//console.log(props);

	const { onLeftClick, onRigthClick, page, totalPages } = props;

	return (
		<div className="pagination">
			<button onClick={onLeftClick} style={{ marginRight: 20 }} className="btn btn-pagination">
				<div>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 21 21"
						width="28"
						height="28"
					>
						<path
							d="M11.5 14.5l-4-4 4-4"
							fill="none"
							stroke="#FFF"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
			</button>

			<div>
				{page} de {totalPages}
			</div>

			<button onClick={onRigthClick} className="btn btn-pagination">
				<div>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 21 21"
						width="28"
						height="28"
					>
						<path
							d="M9.5 14.5l4-4-4-4"
							fill="none"
							stroke="#FFF"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
			</button>
		</div>
	);
};

export default Pagination;
